module.exports = __webpack_public_path__ + "static/media/SOUPS-BNB.21d6894a.svg";